import { Element, useNode } from "@craftjs/core";
import DownloadsIntro from "./components/Intro";
import DownloadsTitle from "./components/Title";

const DownloadsHeader = () => {
    const {
        connectors: { connect },
    } = useNode();

    return (
        <section id="page-hero" className="relative pt-[60px] mb-1" ref={(ref) => connect(ref!)}>
            <div className="container relative mx-auto 2xl:px-[108px] z-[1]mt-10">
                <h1 className="flex content-center gap-3 items-center">
                    <Element id="step-title" is={DownloadsTitle} text="Downloads" />
                </h1>
                <Element
                    id="step-intro"
                    is={DownloadsIntro}
                    text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec quam lacus, tristique at nulla et, imperdiet molestie nibh. Vestibulum mollis viverra odio vitae sodales. Praesent eu pretium purus. Suspendisse potenti. Pellentesque posuere iaculis tempus."
                />
            </div>
        </section>
    );
};

DownloadsHeader.craft = {
    displayName: "Header",
    rules: {
        canDrag: () => false,
        canMoveOut: () => false,
    },
    custom: {
        canDelete: false,
    },
};

export default DownloadsHeader;
